import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { EPageTypes, EPlatformTypes, SimpleCall } from '@cian/frontend-newbuilding-call-component';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';

import { OpenedPhone } from './parts/OpenedPhone';
import { trackBuilderCallReasonsShowing } from './tracking';
import { BuilderCallReasons } from '../../components/BuilderCallReasons';
import { getBuilders, getGaLabel, getNewbuildingId, getSellers } from '../../selectors/newbuilding';
import { setUserOpenedPhoneInNewobject } from '../../utils/lastHopePopup';
import { useApplicationContext } from '../../utils/withApplicationContext';
import { trackShowPhone } from '../Call/tracking';
import { FlatViewOrderPopupContainer } from '../FlatViewOrderPopup';

export const BuilderCallReasonsContainer: React.FC = () => {
  const { httpApi, logger } = useApplicationContext();

  const builders = useSelector(getBuilders);
  const sellers = useSelector(getSellers);
  const newbuildingId = useSelector(getNewbuildingId);
  const gaLabel = useSelector(getGaLabel);

  const handleShowing = React.useCallback(() => {
    trackBuilderCallReasonsShowing();
  }, []);

  const handleShowPhone = React.useCallback(() => {
    setUserOpenedPhoneInNewobject(newbuildingId);
    trackShowPhone(gaLabel, 'Open_ask_builder');
  }, [gaLabel, newbuildingId]);

  const isNewbuildingOnKPN = sellers.some(seller => seller.isLeadFactory);
  const isBuildersWithPhones = builders.filter(builder => builder.phone?.number && builder.showPhone).length > 0;

  const title = isBuildersWithPhones ? 'Спросите у застройщика' : 'Спросите у продавца';
  const buttonText = isBuildersWithPhones ? 'Контакты застройщика' : 'Контакты продавца';

  if (isNewbuildingOnKPN) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={handleShowing} triggerOnce callbackDelay={1000}>
      <BuilderCallReasons
        title={title}
        contactsButton={
          <SimpleCall
            builders={builders}
            sellers={sellers}
            openContactsStyles={{
              size: 'M' as const,
              beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" />,
            }}
            showPhoneBuilderStyles={{
              size: 'M' as const,
              beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" />,
            }}
            showPhoneSellerStyles={{
              size: 'M' as const,
              beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" />,
            }}
            httpApi={httpApi}
            logger={logger}
            onShowPhoneClick={handleShowPhone}
            pageType={EPageTypes.NewbuildingCard}
            platformType={EPlatformTypes.WebDesktop}
            placeType="blockBuilderCallReasons"
            SinglePhoneComponent={OpenedPhone}
            singlePhoneButtonText="Показать телефон"
            multiplePhoneButtonText={buttonText}
          />
        }
        flatViewOrderButton={<FlatViewOrderPopupContainer />}
      />
    </ActionAfterViewObserver>
  );
};
